import { Box, Stack, Text, useColorModeValue } from '@ecoinvent/ui';

import { GeographyHierarchy } from 'hooks/data/search/types';

import NestedCheckbox from './NestedCheckbox';

interface Props {
  specialHierarchy: GeographyHierarchy;
  selectedSpecialGeographies: Record<string, string>;
  effectivelySelectedSpecialCoords: Set<string>;
  onSelect: (geographyName: string, coordinates: string) => void;
}

const SpecialGeographiesPanel = ({
  specialHierarchy,
  selectedSpecialGeographies,
  effectivelySelectedSpecialCoords,
  onSelect,
}: Props) => {
  const titleColor = useColorModeValue('#231F1F', 'gray.100');
  const dividerColor = useColorModeValue('gray.200', 'gray.600');

  const entries = Object.entries(specialHierarchy).sort(([a], [b]) => a.localeCompare(b));

  return (
    <>
      {entries.map(([groupName, groupData], groupIndex) => {
        const children = groupData.children || {};
        const hasAnyChildren = Object.values(children).some((item) => Object.keys(item.children || {}).length > 0);
        const isHorizontal = !hasAnyChildren && Object.keys(children).length <= 8;
        return (
          <Box key={groupName} w="100%">
            {groupIndex > 0 && <Box borderTop="1px solid" borderColor={dividerColor} my={5} />}
            <Stack spacing={3} w="100%">
              <Text fontWeight="semibold" fontSize="md" color={titleColor} pt={4}>
                {groupName}
              </Text>
              {Object.keys(children).length > 0 && (
                <NestedCheckbox
                  data={children}
                  path={String(groupIndex)}
                  onSelect={onSelect}
                  selectedNestedGeographies={selectedSpecialGeographies}
                  effectivelySelectedCoords={effectivelySelectedSpecialCoords}
                  isHorizontal={isHorizontal}
                />
              )}
            </Stack>
          </Box>
        );
      })}
    </>
  );
};

export default SpecialGeographiesPanel;
